import { axiosInstance } from "../../utils/axios";
import { AxiosError } from "axios";
import { DocumentPart } from "../models";
import { TgkElaborationResponse } from "../models/tgk-elaboration-response";
import { TgkImpExpElaborationRequest } from "../models/tgk-imp-exp-elaboration-request";
import { TgkDuplicateElaborationRequest } from "../models/tgk-duplicate-elaboration-request";
import { CheckDuplicate } from "../models/check-duplicate";
import { TgkDetachElaborationRequest } from "../models/tgk-detach-elaboration-request";
import { DocumentUrlProtectionType } from "../models/documenturl-protectiontype";
import { TgkCloneElaborationRequest } from "../models/tgk-clone-elaboration-request";
import { AxiosWrappedApiCall } from "../../utils/helpers/axios.helpers";
import { TgkDownloadCopyElaborationRequest } from "../models/tgk-download-copy-elaboration-request";
import { DocumentItem } from "../models/document-item";

export async function fetchDocuments(): Promise<DocumentPart[]> {
  const resp = await axiosInstance.get("/documentpart");
  return resp.data;
}

export async function fetchDocumentUrl(id: string): Promise<DocumentUrlProtectionType> {
  const resp = await axiosInstance.get(`/documentpart/${id}/url`);
  console.log("Protection type ::::::" + resp.data.protectionType);
  return resp.data;
}

export async function fetchDocumentWebUrl(id: string): Promise<DocumentUrlProtectionType> {
  const resp = await axiosInstance.get(`/documentpart/${id}/weburl`);
  console.log("Protection type ::::::" + resp.data.protectionType);
  return resp.data;
}

export const fetchDocumentPath: AxiosWrappedApiCall<string, [sharepointId: string]> = async (sharepointId, config) => {
  const resp = await axiosInstance.get(`/documentpart/${sharepointId}/path`, config);
  return resp.data;
};

export async function fetchCreatedDocument(documentPart: DocumentPart): Promise<DocumentItem> {
  let response: DocumentItem;
  try {
    let req = await axiosInstance.post("/documentpart/create", JSON.stringify(documentPart), {
      params: { generatesElaboration: true },
    });
    response = req.data;
    response.error = [];
  } catch (error) {
    const err = error as AxiosError;
    if (err.response) {
      return {
        error: [err.response.data],
      };
    }
  }
  return response;
}

export async function exportDocumentRoot(data: TgkImpExpElaborationRequest): Promise<TgkElaborationResponse> {
  const resp = await axiosInstance.post(`documentpart/export`, data, {
    params: { generatesElaboration: true },
  });
  return resp.data;
}

export async function duplicateDocumentRoot(data: TgkDuplicateElaborationRequest): Promise<TgkElaborationResponse> {
  const resp = await axiosInstance.post(`documentpart/duplicate`, data, {
    params: { generatesElaboration: true },
  });
  return resp.data;
}

export async function checkForDuplicate(data: CheckDuplicate): Promise<string[]> {
  const resp = await axiosInstance.post(`documentpart/checkforduplicate`, data);
  return resp.data;
}

export async function importDocumentRoot(data: TgkImpExpElaborationRequest): Promise<TgkElaborationResponse> {
  const resp = await axiosInstance.post(`documentpart/import`, data, {
    params: { generatesElaboration: true },
  });
  return resp.data;
}

export async function detachMultilinkedDocumentPart(
  data: TgkDetachElaborationRequest
): Promise<TgkElaborationResponse> {
  const resp = await axiosInstance.post(`documentpart/detach`, data, {
    params: { generatesElaboration: true },
  });
  return resp.data;
}

export async function cloneDocumentPart(data: TgkCloneElaborationRequest): Promise<TgkElaborationResponse> {
  const resp = await axiosInstance.post(`documentpart/clone`, data, {
    params: { generatesElaboration: true },
  });
  return resp.data;
}

export async function downloadDocumentCopy(
  payload: TgkDownloadCopyElaborationRequest
): Promise<TgkElaborationResponse> {
  const resp = await axiosInstance.post(`downloadDocumentCopy`, payload, { params: { generatesElaboration: true } });
  return resp.data;
}

export async function exportWorkflowHistory(
  payload: TgkDownloadCopyElaborationRequest
): Promise<TgkElaborationResponse> {
  const resp = await axiosInstance.post(`/documentpart/submission/history`, payload, {
    params: { generatesElaboration: true },
  });
  return resp.data;
}
